import { render, staticRenderFns } from "./ShareOffer.vue?vue&type=template&id=4c188587&scoped=true&"
import script from "./ShareOffer.vue?vue&type=script&lang=ts&"
export * from "./ShareOffer.vue?vue&type=script&lang=ts&"
import style0 from "./ShareOffer.vue?vue&type=style&index=0&id=4c188587&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c188587",
  null
  
)

export default component.exports